module.exports = __webpack_public_path__ + "img/album03_11.d0bd5747.jpg";